import { useState, useEffect } from 'react';

/**
 * Hook para gerenciar notificações de recompensa
 * @param {Object} configs - Configurações do usuário
 * @returns {boolean} Se há nova recompensa disponível
 */
export const useRewardNotification = (configs) => {
  const [hasNewReward, setHasNewReward] = useState(false);

  useEffect(() => {
    const hasUnclaimedReward = configs?.dailyReward?.claimed === false;
    setHasNewReward(hasUnclaimedReward);
  }, [configs]);

  return hasNewReward;
};